/*general-setup*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "持续集成",
  "description": "将 Turborepo 与 Vercel、GitHub Actions 和其他持续集成提供商结合使用的技巧。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 不仅可以加快构建速度，还可以通过使用 远程缓存 加快其余的持续集成流水线。以下是一些平台秘诀，用于将 Turborepo 与你的 CI 提供商一起使用。"
  }, {
    "heading": "",
    "content": "¥Turborepo not only speeds up builds, but also the rest of your Continuous Integration pipeline by using Remote Caching. Below are a few platform recipes to use Turborepo with your CI providers."
  }, {
    "heading": "常规设置-general-setup",
    "content": "¥General Setup"
  }, {
    "heading": "常规设置-general-setup",
    "content": "要为你的 CI 启用远程缓存："
  }, {
    "heading": "常规设置-general-setup",
    "content": "¥To enable Remote Caching for your CI:"
  }, {
    "heading": "常规设置-general-setup",
    "content": "在你的 CI 中设置 Turborepo 的环境变量以访问你的远程缓存。"
  }, {
    "heading": "常规设置-general-setup",
    "content": "¥Setup the environment variables for Turborepo in your CI to access your Remote Cache."
  }, {
    "heading": "常规设置-general-setup",
    "content": "变量"
  }, {
    "heading": "常规设置-general-setup",
    "content": "描述"
  }, {
    "heading": "常规设置-general-setup",
    "content": "TURBO_TOKEN"
  }, {
    "heading": "常规设置-general-setup",
    "content": "用于访问远程缓存的 Bearer 令牌"
  }, {
    "heading": "常规设置-general-setup",
    "content": "TURBO_TEAM"
  }, {
    "heading": "常规设置-general-setup",
    "content": "与你的仓库关联的账户名。使用 ' ' Vercel Remote Cache 时，此变量设置为 你团队的 slug。"
  }, {
    "heading": "常规设置-general-setup",
    "content": "克隆你的仓库。"
  }, {
    "heading": "常规设置-general-setup",
    "content": "¥Clone your repository."
  }, {
    "heading": "常规设置-general-setup",
    "content": "通过包管理器安装你的依赖。"
  }, {
    "heading": "常规设置-general-setup",
    "content": "¥Install your dependencies through your package manager."
  }, {
    "heading": "常规设置-general-setup",
    "content": "通过 turbo 运行你的任务。"
  }, {
    "heading": "常规设置-general-setup",
    "content": "¥Run your tasks through turbo."
  }],
  "headings": [{
    "id": "常规设置-general-setup",
    "content": "常规设置 /*general-setup*/"
  }]
};
import {Cards, Card} from '#components/card';
export const toc = [{
  depth: 2,
  url: "#常规设置-general-setup",
  title: _jsx(_Fragment, {
    children: "常规设置 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    ol: "ol",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo 不仅可以加快构建速度，还可以通过使用 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "远程缓存"
      }), " 加快其余的持续集成流水线。以下是一些平台秘诀，用于将 Turborepo 与你的 CI 提供商一起使用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo not only speeds up builds, but also the rest of your Continuous Integration pipeline by using ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), ". Below are a few platform recipes to use Turborepo with your CI providers."]
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "Vercel (Zero configuration)",
        href: "/docs/guides/ci-vendors/vercel"
      }), _jsx(Card, {
        title: "GitHub Actions",
        href: "/docs/guides/ci-vendors/github-actions"
      }), _jsx(Card, {
        title: "CircleCI",
        href: "/docs/guides/ci-vendors/circleci"
      }), _jsx(Card, {
        title: "GitLab CI",
        href: "/docs/guides/ci-vendors/gitlab-ci"
      }), _jsx(Card, {
        title: "Travis CI",
        href: "/docs/guides/ci-vendors/travis-ci"
      }), _jsx(Card, {
        title: "Buildkite",
        href: "/docs/guides/ci-vendors/buildkite"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "常规设置-general-setup",
      children: "常规设置 "
    }), "\n", _jsx(_components.p, {
      children: "¥General Setup"
    }), "\n", _jsx(_components.p, {
      children: "要为你的 CI 启用远程缓存："
    }), "\n", _jsx(_components.p, {
      children: "¥To enable Remote Caching for your CI:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "在你的 CI 中设置 Turborepo 的环境变量以访问你的远程缓存。"
        }), "\n", _jsx(_components.p, {
          children: "¥Setup the environment variables for Turborepo in your CI to access your Remote Cache."
        }), "\n", _jsxs(_components.table, {
          children: [_jsx(_components.thead, {
            children: _jsxs(_components.tr, {
              children: [_jsx(_components.th, {
                children: "变量"
              }), _jsx(_components.th, {
                children: "描述"
              })]
            })
          }), _jsxs(_components.tbody, {
            children: [_jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: _jsx(_components.code, {
                  children: "TURBO_TOKEN"
                })
              }), _jsx(_components.td, {
                children: "用于访问远程缓存的 Bearer 令牌"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: _jsx(_components.code, {
                  children: "TURBO_TEAM"
                })
              }), _jsxs(_components.td, {
                children: ["与你的仓库关联的账户名。使用 ", ' ', " ", _jsx("a", {
                  href: "https://vercel.com/docs/monorepos/remote-caching#vercel-remote-cache",
                  rel: "noreferrer noopener",
                  target: "_blank",
                  children: "Vercel Remote Cache"
                }), " 时，此变量设置为 ", _jsx(_components.a, {
                  href: "https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fsettings&title=Get+team+slug",
                  children: "你团队的 slug"
                }), "。"]
              })]
            })]
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "克隆你的仓库。"
        }), "\n", _jsx(_components.p, {
          children: "¥Clone your repository."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "通过包管理器安装你的依赖。"
        }), "\n", _jsx(_components.p, {
          children: "¥Install your dependencies through your package manager."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["通过 ", _jsx(_components.code, {
            children: "turbo"
          }), " 运行你的任务。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Run your tasks through ", _jsx(_components.code, {
            children: "turbo"
          }), "."]
        }), "\n"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
